export default __webpack_public_path__ + "static/background-hero-home-inter-asset-xl-80c10f4a8c07fe7363b95137f12da50f.png";